import React from "react";
import ReactDOM from 'react-dom/client';
import { AppProvider, Page } from "@shopify/polaris";
import enTranslations from '@shopify/polaris/locales/en.json';
import { store, StoreContext } from "./app/stores/store";
import "@shopify/polaris/build/esm/styles.css";
import "./styles.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./app/router/Routes";
import reportWebVitals from "./reportWebVitals";
import { NavMenu } from "@shopify/app-bridge-react";
// export const history = createBrowserHistory();


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <AppProvider
    i18n={enTranslations}>
      {new URLSearchParams(window.location.search).has('host') && (
        <NavMenu>
          <a href="/" rel="home">
            Home
          </a>
          <a href="/dashboard">Dashboard</a>
          <a href="/products">Products</a>
          <a href="/vehicles">Vehicles</a>
          <a href="/imports">Imports</a>
          <a href="/settings">Settings</a>
        </NavMenu>
      )}
        <Page fullWidth>
            <StoreContext.Provider value={store}>
                <RouterProvider router={router} />
            </StoreContext.Provider>
        </Page>
  </AppProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
